import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const RoleBasedRoute = ({ allowedRoles, children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div>Loading...</div>;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const userRole = (currentUser.role?.name || "").toLowerCase();
  const allowed = allowedRoles.map((role) => role.toLowerCase());

  if (allowed.includes(userRole)) {
    return children;
  } else {
    return <Navigate to="/" replace />;
  }
};

export default RoleBasedRoute;
